import Vue from 'vue'
import qs from 'qs'

export default {
  deposits (params) {
    return Vue.$http.get('v1/deposits', {
      params,
      paramsSerializer (params) {
        return qs.stringify(params, {encode: false})
      }
    })
  },
  get (id) {
    return Vue.$http.get(`v1/deposits/${id}`)
  },
  add (deposit) {
    return Vue.$http.post('v1/deposits/add', deposit)
  },
  update (deposit) {
    return Vue.$http.post(`v1/deposits/${deposit.id}`, deposit)
  },
  updateWithFiles (id, deposit) {
    return Vue.$http.post(`v1/deposits/${id}`, deposit)
  },
  remove (id) {
    return Vue.$http.post(`v1/deposits/${id}/delete`)
  },
  arch (id) {
    return Vue.$http.post(`v1/deposits/${id}/arch`)
  },
  register (id) {
    return Vue.$http.post(`v1/deposits/${id}/register`)
  },
  certificate (id) {
    return Vue.$http.get(`v1/deposits/${id}/pdf`, {
      responseType: 'blob'
    })
  },
  loadTags (q) {
    return Vue.$http.get('v1/tags', {data: {q}})
  },
}
